import type React from 'react';

// Controls that do their own thing when clicked.
const OWN_CONTROLS = 'button, a, input, select, textarea, [role="button"], [tabindex]:not([tabindex="-1"])';

/**
 * Should a click on a clickable surface — a panel header, a table group row —
 * toggle it?
 *
 * Only when it landed on the surface itself. Not on a control inside it (a
 * select, an info icon, its own toggle button, which acts on its own), and
 * not in a pop-up one of those controls opened: React passes those clicks up
 * through the tree even though they are drawn elsewhere on the page.
 */
export function isSurfaceClick(event: React.MouseEvent<HTMLElement>): boolean {
  const surface = event.currentTarget;
  const target = event.target as HTMLElement;
  if (!surface.contains(target)) return false;
  // Only controls between the click and the surface count. A focusable
  // ancestor around the whole surface — a scroll area that takes arrow keys —
  // is not a control inside it, and must not swallow every click.
  const control = target.closest(OWN_CONTROLS);
  return !control || control === surface || !surface.contains(control);
}
